import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Keyboard-shortcuts cheat sheet open/close state (NS-4).
 *
 * The `?` global shortcut opens a modal listing every keybinding in the
 * app. Kept as a dedicated store (not inline ref in AppShell) so any
 * component can open the cheat sheet programmatically — a `?` hint
 * button in the TopBar, for example.
 *
 * Composition-style per CLAUDE.md §Frontend Principles §1.
 */
export const useKeyboardShortcutsStore = defineStore('keyboardShortcuts', () => {
  const open = ref(false);

  function openModal() {
    open.value = true;
  }

  function closeModal() {
    open.value = false;
  }

  function toggle() {
    open.value = !open.value;
  }

  return { open, openModal, closeModal, toggle };
});
